import { poTemplateSchema } from "@redotech/redo-model/purchase-order-document";
import * as z from "zod";

export const createPoTemplate = {
  name: "createPoTemplate" as const,
  input: z.object({
    name: z.string(),
    copyFromTemplateId: z.string().optional(),
  }),
  output: poTemplateSchema,
};
